import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class AskMarketplaceAssistantResponse extends SuccessfulApiResponse {
    answer() {
        return this.content().answer;
    }
}
